import React from "react";
import { Store, Award, PartyPopper, Check } from "lucide-react";

const models = [
    {
        icon: Store,
        title: "Operador Independente",
        subtitle: "Para quem quer começar pequeno",
        bullets: [
            "Carrinho ou ponto fixo",
            "Suporte e formação",
            "Material de marketing",
        ],
        cta: "Saber mais",
        accent: "text-brand-green",
        bg: "bg-white",
        ring: "ring-brand-green/15",
    },
    {
        icon: Award,
        title: "Licenciamento",
        subtitle: "O modelo mais completo",
        bullets: [
            "Marca, sistema e know-how",
            "Equipamento incluído",
            "Acompanhamento dedicado",
            "Zona de exclusividade",
        ],
        cta: "Quero licenciar",
        accent: "text-white",
        bg: "bg-brand-green",
        ring: "ring-brand-green/30",
        highlight: true,
    },
    {
        icon: PartyPopper,
        title: "Eventos e Catering",
        subtitle: "Para festivais, hotéis e empresas",
        bullets: [
            "Operação plug-and-play",
            "Sem necessidade de frio",
            "Cobrança por evento",
        ],
        cta: "Pedir orçamento",
        accent: "text-brand-orange",
        bg: "bg-white",
        ring: "ring-brand-orange/20",
    },
];

export const Partnership = () => {
    return (
        <section className="py-20 md:py-28 bg-brand-cream">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                        Modelos de parceria
                    </span>
                    <h2 className="mt-3 font-display font-medium text-4xl md:text-5xl text-brand-ink leading-tight">
                        Três caminhos para crescer connosco.
                    </h2>
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-5 md:gap-6 items-stretch">
                    {models.map((m) => (
                        <article
                            key={m.title}
                            data-testid={`partnership-${m.title.toLowerCase().replace(/\s/g, "-")}`}
                            className={`relative rounded-2xl p-8 md:p-10 ring-1 ${m.ring} ${m.bg} ${m.highlight ? "lg:scale-105 shadow-pop md:-translate-y-2" : "shadow-soft"} flex flex-col transition-all hover:-translate-y-1`}
                        >
                            {m.highlight && (
                                <div className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1.5 rounded-full bg-brand-orange text-white text-[11px] uppercase tracking-widest font-bold px-3 py-1.5 shadow-pop">
                                    Mais escolhido
                                </div>
                            )}
                            <div
                                className={`h-14 w-14 rounded-2xl flex items-center justify-center ${m.highlight ? "bg-white/15" : "bg-brand-green-soft"}`}
                            >
                                <m.icon className={`h-6 w-6 ${m.accent}`} />
                            </div>
                            <h3
                                className={`mt-6 font-display font-medium text-2xl ${m.highlight ? "text-white" : "text-brand-ink"}`}
                            >
                                {m.title}
                            </h3>
                            <p
                                className={`mt-1 text-sm ${m.highlight ? "text-white/80" : "text-brand-ink-soft"}`}
                            >
                                {m.subtitle}
                            </p>

                            <ul className="mt-6 space-y-3 flex-1">
                                {m.bullets.map((b) => (
                                    <li key={b} className="flex items-start gap-2 text-sm">
                                        <Check
                                            className={`h-4 w-4 mt-0.5 shrink-0 ${m.highlight ? "text-brand-orange" : "text-brand-green"}`}
                                        />
                                        <span
                                            className={
                                                m.highlight
                                                    ? "text-white/90"
                                                    : "text-brand-ink-soft"
                                            }
                                        >
                                            {b}
                                        </span>
                                    </li>
                                ))}
                            </ul>

                            <a
                                href="#contacto"
                                className={`mt-8 inline-flex items-center justify-center rounded-full px-5 py-3 text-sm font-semibold transition-all ${
                                    m.highlight
                                        ? "bg-white text-brand-green hover:bg-brand-orange hover:text-white"
                                        : "bg-brand-ink text-white hover:bg-brand-green"
                                }`}
                                data-testid={`partnership-cta-${m.title.toLowerCase().replace(/\s/g, "-")}`}
                            >
                                {m.cta}
                            </a>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};
